// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1I9rx","emails":"CreateEditClinics_emails__3ens4","emailTagLabel":"CreateEditClinics_emailTagLabel__3DVnv"};